import mapFunction from './mapResources';

export default mapFunction('tool_categories', {
    isFetching: false,
    items: [] 
});